import { trackSignalWithAck } from '@/lib/api/signals';
import { useAuthStore } from '@/stores/authStore';
import { getAcquisitionVisitClaim } from './acquisition';

export type FunnelEvent = 'generation_attempted' | 'generation_submitted' | 'pricing_opened' | 'checkout_started';
const pending = new Set<string>();
const sent = new Set<string>();

/** Content-free action facts. Orders/tasks/profile creation remain the conversion authority. */
export function trackFunnelEvent(event: FunnelEvent, identity?: string): void {
  try {
    const auth = useAuthStore.getState();
    if (!auth.isAuthenticated || !auth.user?.id || auth.user.isAdmin) return;
    const userId = auth.user.id;
    const eventId = `funnel:${event}:${identity ?? crypto.randomUUID()}`;
    const key = `${userId}:${eventId}`;
    if (pending.has(key) || sent.has(key)) return;
    try { if (window.localStorage.getItem(key)) return; } catch { /* In-memory dedupe remains available. */ }
    const isCurrent = () => {
      const state = useAuthStore.getState();
      return state.isAuthenticated && state.user?.id === userId && !state.user.isAdmin;
    };
    pending.add(key);
    void trackSignalWithAck('journey', {
      schema_version: 1, event_name: event, event_id: eventId,
      occurred_at: new Date().toISOString(), client_surface: 'web',
      acquisition_visit_id: getAcquisitionVisitClaim()?.id,
      route: window.location.pathname, action: event,
    }, undefined, isCurrent).then(ok => {
      if (!ok) return;
      sent.add(key);
      // Only per-order checkout identities need cross-document persistence.
      if (event === 'checkout_started') {
        try { window.localStorage.setItem(key, '1'); } catch { /* No storage cannot interrupt checkout. */ }
      }
    }).catch(() => {}).finally(() => pending.delete(key));
  } catch { /* Analytics never changes the result of an action. */ }
}
